import { render, staticRenderFns } from "./BSFilterTextfield.vue?vue&type=template&id=3a251708&scoped=true"
import script from "./BSFilterTextfield.vue?vue&type=script&lang=js"
export * from "./BSFilterTextfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a251708",
  null
  
)

export default component.exports